export default class TranscriptCourseAttendanceService {
    static createStub(status, options = {}) {
        const defaultOptions = {
            courseSectionScheduleElementId: 0,
            manuallyExcused: false,
            excusedRuleApplies: false,
            comment: "",
        };
        const safeOptions = Object.assign(Object.assign({}, defaultOptions), options);
        return {
            id: 0,
            attendanceAlertGenerated: false,
            attendanceDate: new Date(),
            courseSectionScheduleElement: {
                id: safeOptions.courseSectionScheduleElementId,
            },
            createdBy: { id: "0" },
            createdDate: new Date(),
            meetingType: "",
            modifiedBy: { id: "0" },
            srcSystemId: "0",
            sisImportCreatedDate: new Date(),
            sisImportModifiedDate: new Date(),
            transcriptCourse: { id: "0" },
            transcriptCourseAttendanceStatus: { id: status },
            manuallyExcused: safeOptions.manuallyExcused,
            excusedRuleApplies: safeOptions.excusedRuleApplies,
            comment: safeOptions.comment,
        };
    }
    static isExcused(attendance) {
        return attendance.manuallyExcused || attendance.excusedRuleApplies;
    }
}
